// Use credentials as default
export const WITH_CREDENTIALS = true;

/**
 * Increase timeout for live system because 10s were too less
 * @see https://jira.migros.net/browse/PULSWM-2969
 */
export const TIMEOUT = 20 * 1000;
